import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Data, Router } from '@angular/router';
import { Session } from '../services/session';

@Injectable()
export class SubscriptionPlanGuard {
  constructor(private router: Router, @Inject(Session) private session) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const routeData: Data = route.data;
    const config: { plans: string[], redirectTo: string } = routeData.subscriptionPlanGuard;
    const plans: string[] = config.plans; // ELD Starter, ELD Plus
    const redirectTo: string = config.redirectTo || '';

    if (plans.indexOf(this.session.getCompanyProperty('subscription_plan')) > -1) return true;
    this.router.navigate([redirectTo]);
    return false;
  }
}
